<tran-application-detail-dashboard-box>
    @if (isLoading()) {
        <div class="flex flex-col gap-3" aria-hidden="true">
            <span class="si-skeleton w-20"></span>
            <span class="si-skeleton w-24"></span>
        </div>
    } @else if (this.readonly()) {
        <tran-dashboard-tile
            class="w-full h-full"
            icon="element-user-group"
            property="application-detail.affected-employees"
            [kpi]="value() || undefined"
        />
    } @else {
        <si-form-item
            [label]="'application-detail.affected-employees' | translate"
            [formErrorMapper]="{
                required: 'application-form.required' | translate,
                min: 'application-form.number-min1' | translate
            }"
        >
            <tran-number-input
                class="form-control"
                [formControl]="effectiveControl()"
                [disabled]="readonly() || effectiveControl().disabled"
                [min]="0"
                [step]="10"
                [placeholder]="'application-form.example-1' | translate"
            />
        </si-form-item>
    }
</tran-application-detail-dashboard-box>
